
const manageEditCompanySettings = 'manage.editCompany.settings'

const manageEditCompanySettingsConfig = {
  url: '/settings',
  component: 'companySettings',
}

export { manageEditCompanySettings, manageEditCompanySettingsConfig }
